module.exports = __webpack_public_path__ + "img/eirin yagokoro.682eb220.png";